'use client';

import { Box } from "@chakra-ui/react";
import { useEffect, useState } from 'react';
import { theCat, theContent, headerDated, addressInfo, luIcon } from "@/helpers/utils";
import "./content.css"

export function InnerHtml({ html }) {
  return (
    <Box className="content" suppressHydrationWarning={true} dangerouslySetInnerHTML={{ __html: html }}></Box>
  )
}

export function TheContent({ body }) {
  return (
    <>
      { theContent(body) }
    </>
  )
}

export function HeaderDated({ date }) {
  return (
    <>
      { headerDated(date) }
    </>
  )
}

export function TheCat({ cats, k = false }) {
  return (
    <>
      { theCat(cats, k) }
    </>
  )
}

export function AddressInfo({ joinType }) {
  return (
    <>
      { addressInfo(joinType)  }
    </>
  )
}

export function LuIcon({ icon, size = 'sm' }) {
  return (
    <>
      { luIcon(icon, size)  }
    </>
  )
}
